

import en from 'config/strings'
import { validateEmail, validateIsraeliId, validateIsraeliIdOrPassport, validatePassword, validatePhoneNumber } from 'utils/validation'

//validation login form
const validate = (values) => {
    const { filled_fields, en_first_name, en_last_name, username, email, tz, password, first_name, last_name, gender, phone } = values || {}
    const errors = {}

    if (values) {

        if (username) {
            if (!/^[A-Za-z0-9@.+\-_]{1,150}$/.test(username))
                errors.username = en.invalidUsername
        }
        else if (!filled_fields?.username)
            errors.username = en.require('')

        errors.password = validatePassword(password)

        if (!first_name) errors.first_name = en.require()

        if (!last_name) errors.last_name = en.require('')

        if (!gender) errors.gender = en.require('')

        if (phone)
            errors.phone = validatePhoneNumber(values.phone)
        else
            if (!filled_fields?.phone_number) // DB יש לגשת בשמות השדות ה
                errors.phone = en.require()

        if (email)
            errors.email = validateEmail(values.email)
        else
            if (!filled_fields?.email) // DB יש לגשת בשמות השדות ה
                errors.email = en.require()

        if (!en_first_name)
            errors.en_first_name = en.require()

        if (!en_last_name)
            errors.en_last_name = en.require()


        if (!tz)
            errors.tz = en.require()
        else if (!validateIsraeliId(tz))
            errors.tz = en.invalidTZ

    }

    return errors;
}

export default validate

